module.exports = __webpack_public_path__ + "img/更多商业服务.480bd0d3.png";